<dl class="pb-c-accordion">
    <dt class="pb-flex pb-items-center pb-text-h-xs-m lg:pb-text-h-xs pb-justify-between pb-pr-3 pb-cursor-pointer pb-py-5" (click) = "expand()" [class.pb-c-accordion--expanded]="expanded == true">
        <h4 class="pb-w-11/12 pb-font-bold"> {{ data.Question }}</h4>
        <i class="flex items-center pb-icon pb-icon-add pb-font-bold pb-icon-color-default"></i>
    </dt>
    <dd>
        <div class="pb-article pb-article-piraeus" appRichTextRouter [innerHtml]="data.Answer"></div>
    </dd>
</dl>